import {
  useInfiniteData,
  UseInfiniteDataProps,
} from '@common/ui/infinite-scroll/use-infinite-data';
import { LiveEventOrderItem } from '@app/admin/live-events/interfaces/live-event-order';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';


export const libraryLiveEventTicketsQueryKey = (
  userId: number | 'me',
  queryParams?: Record<string, string | number>,
) => {
  const user = getBootstrapData().user;
  // make sure we are using "me" as ID for current user
  // everywhere, so it's easier to invalidate queries
  if (userId === user?.id) {
    userId = 'me';
  }
  const key: any[] = ['tickets', 'library', userId];
  if (queryParams) {
    key.push(queryParams);
  }
  return key;
};

export function useUserLiveEventTickets(
  userId: number | 'me',
  options?: Partial<UseInfiniteDataProps<LiveEventOrderItem>>,
) {
  return useInfiniteData<LiveEventOrderItem>({
    queryKey: libraryLiveEventTicketsQueryKey(userId),
    endpoint: `users/${userId}/tickets`,
    defaultOrderBy: 'created_at',
    defaultOrderDir: 'desc',
    ...options,
  });
}
